const DIVISOR = [
  'none',
  'hundreds',
  'thousands',
  'millions',
  'billions',
  'trillions'
];

export default DIVISOR;
